import React from "react";

import SnippetSearchResult
from "./SnippetSearchResult";


//========================================================
// Snippet Search Results
//========================================================

export default function SnippetSearchResults({

    results,

    total,

    page,

    size,

    loading,

    onInspect,

    onNext,

    onPrevious

})
{
    if (loading)
    {
        return (
            <div style={styles.message}>
                Sniffing snippets...
            </div>
        );
    }

    if (!results.length)
    {
        return null;
    }

    const from =
        (page * size) + 1;

    const to =
        Math.min(
            (page + 1) * size,
            total
        );

    return (
        <div style={styles.container}>
            <div style={styles.summary}>
                Showing {from}–{to} of{" "}
                {total.toLocaleString()} matches
            </div>

            {
                results.map(
                    result =>
                        <SnippetSearchResult
                            key={result.snippetId}
                            result={result}
                            onInspect={onInspect}
                        />
                )
            }

            <div style={styles.pagination}>
                <button
                    onClick={onPrevious}
                    disabled={page === 0}
                >
                    Previous
                </button>

                <span>
                    Page {page + 1}
                </span>

                <button
                    onClick={onNext}
                    disabled={
                        (page + 1) * size
                        >= total
                    }
                >
                    Next
                </button>
            </div>
        </div>
    );
}


//========================================================
// Styles
//========================================================

const styles =
{
    container:
    {
        width: "100%",
        maxWidth: "900px",
        marginTop: "24px"
    },

    summary:
    {
        marginBottom: "12px",
        fontSize: "13px",
        color: "#7b8791"
    },

    message:
    {
        marginTop: "30px",
        fontSize: "14px",
        color: "#7b8791"
    },

    pagination:
    {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "18px 0"
    }
};